"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Custom API error codes
 * Handles 200 cases with empty data
 * To-do: will move to SDK side once it is stable
 */
var _default = exports["default"] = {
  PR404: 'PR404',
  // fleet pricing no data
  PR408: 'PR408',
  // fleet price completed with failure
  BR404: 'BR404',
  // branch no data
  CY404: 'CY404',
  // city no data
  GR404: 'GR404',
  // fleet group no data
  CN404: 'CN404',
  // country no data
  BL404: 'BL404',
  // booking list no data
  PRL404: 'PRL404' // promo list no data
};